import React, { FC, HTMLProps } from 'react';

import clsx from 'clsx';

import { useTranslate } from '@/hooks/use-translate';

import { en } from './en';
import { NotFoundIcon } from './icon';

import styles from './EmptyStateResult.module.scss';

export enum PageType {
	FishSearch = 'FishSearch',
	WarehousesSearch = 'WarehousesSearch',
}

type Props = {
	pageType: PageType;
};

type OwnProps = HTMLProps<HTMLDivElement> & Props;

export const EmptyStateResult: FC<OwnProps> = ({ pageType, className }) => {
	const t = useTranslate(en);

	const getNotFoundText = () => {
		return pageType === PageType.FishSearch
			? t(
				'К сожалению, по вашему запросу ничего не нашлось. Подпишитесь на результаты поиска — мы сообщим вам, как только появится подходящее предложение.',
			)
			: t(
				'К сожалению, мы не нашли склады, отвечающие критериям вашего запроса. Подобрали несколько предложений, которые отвечают указанным параметрам, но расположены дальше.',
			);
	};

	return (
		<div className={clsx(styles.fishBuy404, className)}>
			<NotFoundIcon />
			<p className={styles.fishBuy404Text}>{getNotFoundText()}</p>
		</div>
	);
};
